import { createContext } from 'react';

export interface UserActivity {
    votes: number;
    pollsCreated: number;
    comments: number;
    shares: number;
    activitySince: number;
}

export interface UserActivityContextType {
    userActivity: UserActivity;
    setUserActivity: (ua: UserActivity) => void;
}

export const UserActivityContext = createContext<UserActivityContextType>({
    userActivity: {
        votes: 0,
        pollsCreated: 0,
        comments: 0,
        shares: 0,
        activitySince: 0,
    },
    setUserActivity: (_ua: UserActivity) => {},
});
